export class StepUpCancelledError extends Error {
  constructor() {
    super("step_up_cancelled");
    this.name = "StepUpCancelledError";
    Object.setPrototypeOf(this, StepUpCancelledError.prototype);
  }
}
